import { render } from "./EquipmentAbout.vue?vue&type=template&id=fc30db00&scoped=true"
const script = {}

import "./EquipmentAbout.vue?vue&type=style&index=0&id=fc30db00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc30db00"]])

export default __exports__